export const QUESTION_TYPES = Object.freeze([
  { value: "MULTIPLE_CHOICE", label: "Multiple Choice" },
  { value: "SELECT_ALL", label: "Select All That Apply" },
  { value: "SCALE", label: "Scale" },
  { value: "LIKERT", label: "Likert Scale" },
  { value: "SHORT_ANSWER", label: "Short Answer" },
]);

const MAX_INT_SIZE = 2147483647;

export const QUESTION_CONTENT_MAX_LENGTH = 750;
export const ANSWER_CONTENT_MAX_LENGTH = 255;
export const SCALE_MAX_RANGE = 1000;
export { MAX_INT_SIZE };

export function createQuestion(overrides = {}) {
  return {
    learningQuizQuestionId: null,
    learningCardId: null,
    content: null,
    type: "MULTIPLE_CHOICE",
    lowerBound: null,
    upperBound: null,
    required: true,
    LearningQuizAnswers: [createAnswer()],
    ...overrides,
  };
}

export function createAnswer(overrides = {}) {
  return {
    learningQuizAnswerId: null,
    learningQuizQuestionId: null,
    type: "text",
    content: null,
    correctness: 0,
    ...overrides,
  };
}

export function hasAnswerList(type) {
  return type === "MULTIPLE_CHOICE" || type === "SELECT_ALL";
}

export function hasScaleBounds(type) {
  return type === "SCALE";
}

/**
 * Resets answers and bounds when a question's type changes.
 * Returns deleted answer IDs (for backend sync) so the consumer can track them.
 */
export function resetAnswersForType(question) {
  const deletedIds = question.LearningQuizAnswers.filter((a) => a.learningQuizAnswerId).map(
    (a) => a.learningQuizAnswerId
  );

  question.lowerBound = null;
  question.upperBound = null;

  if (["MULTIPLE_CHOICE", "SCALE"].includes(question.type)) {
    question.LearningQuizAnswers = [createAnswer()];
  } else if (question.type === "SELECT_ALL") {
    question.LearningQuizAnswers = [createAnswer(), createAnswer()];
  } else {
    question.LearningQuizAnswers = [];
  }

  return deletedIds;
}
